import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'py-4' : 'py-6'
      }`}
      style={{
        backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        boxShadow: scrolled ? '0 4px 24px rgba(0, 0, 0, 0.06)' : 'none'
      }}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/21cdb0ce-06f2-4f24-a879-a7c95c269052.png" 
              alt="FlexDown" 
              className="h-8 w-auto cursor-pointer"
            />
          </div>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a 
              href="#listings" 
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1E4FFF]' : 'text-white/90 hover:text-white'
              }`}
            >
              Listings
            </a>
            <a 
              href="#management" 
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1E4FFF]' : 'text-white/90 hover:text-white'
              }`}
            >
              Management
            </a>
            <a 
              href="#valuation" 
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1E4FFF]' : 'text-white/90 hover:text-white'
              }`}
            >
              Valuation
            </a>
            <a 
              href="#about" 
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1E4FFF]' : 'text-white/90 hover:text-white'
              }`}
            >
              About
            </a>
          </nav>

          {/* Right Actions */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/signin')}
              className={`hidden md:block px-6 py-2.5 text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                scrolled 
                  ? 'text-gray-700 hover:text-[#1E4FFF]' 
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Sign In
            </button>
            
            <button 
              onClick={() => navigate('/getstarted')}
              className="px-6 py-2.5 rounded-xl text-sm font-medium text-white whitespace-nowrap transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer"
              style={{ backgroundColor: '#1E4FFF' }}
            >
              Get Started
            </button>

            {/* Mobile Menu Button */}
            <button 
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
